import { ajaxPostJson, setParams, ajaxGetJson2 } from './ajax';
// 老师端分页列表数据查询
export const queryJobData = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/project/queryFilePage`, params);
};
//查询项目详情
export const queryProjectTermMemoryList = (params) => {
  return ajaxPostJson(`/project/queryProjectTermMemoryList`, params);
};
//查询成员
export const companyUser = (params) => {
  return ajaxPostJson(`/fileTask/getAllowAppointUserList`, params);
};
// 根据文件查询详情
export const projectTermMemory = (params) => {
  return ajaxPostJson(`/file/get`, params);
};
// 根据项目查询文件
export const queryFile = (params) => {
  return ajaxPostJson(`/project/queryFile`, params);
};
// 根据文件id分配任务
export const fileAppoint = (params) => {
  return ajaxPostJson(`/fileTask/appoint`, params);
};
// 分页查询作业
export const queryFilePage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/project/queryFilePage`, params);
};
// 项目详情页，查询学生进度---老师端
export const queryTaskPage = (params) => {
  return ajaxPostJson(`/fileTask/queryTaskPage`, params);
};
// 项目详情页，查询学生进度---学生端
export const queryMyTaskPage = (params) => {
  return ajaxPostJson(`/fileTask/queryMyTaskPage`, params);
};
// 查询所有领域
export const queryDomainList = (params) => {
  return ajaxPostJson(`/project/queryDomainList`, params);
};
// 修改项目信息
export const updateProject = (params) => {
  return ajaxPostJson(`/project/updateTransProject`, params);
};
// 作业模式获取下载地址
export const getWorkReport = (params) => {
  return ajaxPostJson(`/fileTask/getWorkReport`, params);
};
// 我的作业/我的测试分页查询
export const queryPageMyTask= (params) => {
  return ajaxPostJson(`/fileTask/query_page/my_task`, params);
};
//统计用户文件完成量
export const countUserFinishWordNum= (params) => {
  params= setParams(params);
  return ajaxPostJson(`/fileTask/countUserFinishHomeWorkNum`, params);
};

// 班级管理新加接口
// 查询班级
export const queryClass = (params) => {
  return ajaxPostJson(`/companyUser/queryClass`, params);
};
// 分配作业
export const assignJobToTheClass = (params) => {
  return ajaxPostJson(`/fileTask/assignJobToTheClass`, params);
};
// 根据文件查询分配的班级
export const queryClassByFile = (params) => {
  return ajaxPostJson(`/fileTask/queryClassByFile`, params);
};
// 查看班级完成情况
export const queryClassOperation = (params) => {
  return ajaxPostJson(`/fileTask/queryClassOperation`, params);
};
// 班级作业分页
export const queryClassTaskPage = (params) => {
  return ajaxPostJson(`/fileTask/queryClassTaskPage`, params);
};
// 查看作业详情
export const queryClassTaskDetail = (params) => {
  return ajaxPostJson(`/project/getClassTaskDetail`, params);
};
// 浏览作业
export const viewHomeWorkPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/fileTask/viewHomeWorkPage`, params);
};
// 取消作业
export const cancelJob = (params) => {
  return ajaxPostJson(`/fileTask/cancelJob`, params);
};
// 作业管理下载报告
export const downloadHomeworkReport = (params) => {
  return ajaxPostJson(`/fileTask/downloadHomeworkReport`, params);
};
// 项目下载，作业就是项目
export const exportAsyncProject = (params) => {
  return ajaxGetJson2(`/file/exportAsyncProject`, params);
};
// 老师端作业管理   下载个人单个个作业统计报告
export const downloadStudentOneHomeworkReport = (params) => {
  return ajaxPostJson(`/fileTask/downloadStudentOneHomeworkReport`, params);
};
// 老师端作业管理   下载班级单个作业统计报告
export const downloadOneClassHomeworkReport = (params) => {
  return ajaxPostJson(`/fileTask/downloadOneClassHomeworkReport`, params);
};

// 我的作业
// 分页查询学生作业
export const queryPageHomework = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/fileTask/queryPageHomework`, params);
};
// 离线下载任务
export const outLineEditDownload = (params) => {
  return ajaxGetJson2(`/file/outLineEditDownload`, params);
}
//重新上传
export const reUploadFileAsync = (params) => {
  return ajaxPostJson(`/file/file_repeat_upload`, params);
};